module.exports = __webpack_public_path__ + "img/2179.f803c012.gif";